// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider_slider_box__miL7n {
  height: auto;
  width: auto;
  background-color: var(--primary-color);

  .slider_card__62wmA {
    position: relative;

    & h1 {
      color: rgba(255, 255, 255, 0.14);
      font-family: Inter;
      font-size: 3rem;
      font-weight: 700;
    }

    & h2 {
      padding-top: 1.1rem;
      color: #fff;
      font-family: Inter;
      font-size: 1.3rem;
      font-weight: 600;
    }

    & p {
      color: #fff;
      font-family: Inter;
      font-size: 0.87rem;
      font-weight: 500;
    }
  }

  .slider_left__i86qz {
    height: auto;
    width: 100%;
    padding: 1rem;
  }
}
@media screen and (max-wdith: 568px) {
  .slider_card__62wmA {
    height: 600px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/SwiperSlider/slider.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,sCAAsC;;EAEtC;IACE,kBAAkB;;IAElB;MACE,gCAAgC;MAChC,kBAAkB;MAClB,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,mBAAmB;MACnB,WAAW;MACX,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;IAClB;EACF;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".slider_box {\n  height: auto;\n  width: auto;\n  background-color: var(--primary-color);\n\n  .card {\n    position: relative;\n\n    & h1 {\n      color: rgba(255, 255, 255, 0.14);\n      font-family: Inter;\n      font-size: 3rem;\n      font-weight: 700;\n    }\n\n    & h2 {\n      padding-top: 1.1rem;\n      color: #fff;\n      font-family: Inter;\n      font-size: 1.3rem;\n      font-weight: 600;\n    }\n\n    & p {\n      color: #fff;\n      font-family: Inter;\n      font-size: 0.87rem;\n      font-weight: 500;\n    }\n  }\n\n  .left {\n    height: auto;\n    width: 100%;\n    padding: 1rem;\n  }\n}\n@media screen and (max-wdith: 568px) {\n  .card {\n    height: 600px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slider_box": `slider_slider_box__miL7n`,
	"card": `slider_card__62wmA`,
	"left": `slider_left__i86qz`
};
export default ___CSS_LOADER_EXPORT___;
